import ReactDOM from 'react-dom';

import './style.css';
import App from './app';

window.addEventListener('load', () => {
  ReactDOM.render(<App />, document.getElementById('root'));
});
